import { FC } from 'react';

import { AWARDS_IMAGES } from '@/components/Awards/assets';
import AwardItem from '@/components/CaseStudy/Hero/AwardItem';
import { CaseStudyAwardDto } from '@/types/case-studies';

import css from './style.module.scss';

interface Props {
	awards?: CaseStudyAwardDto[];
}

const CardAwards: FC<Props> = ({ awards }) => {
	const items = awards?.filter(award => AWARDS_IMAGES[award.type]);

	if (!items?.length) return null;

	return (
		<ul className={css.awards}>
			{items.map(award => (
				<li key={award.id}>
					<AwardItem award={award} />
				</li>
			))}
		</ul>
	);
};

export default CardAwards;
